import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { Play, Trash2, Youtube } from "lucide-react";
import { videoEmbed } from "@/lib/media";
import { cn } from "@/lib/utils";

const VideoView = ({ node, updateAttributes, deleteNode, selected }) => {
  const v = videoEmbed(node.attrs.url);
  return (
    <NodeViewWrapper as="div" data-type="video" className={cn("hk-video", selected && "is-selected")} contentEditable={false} data-testid="editor-video">
      {v ? (
        <div className="hk-video-frame" data-drag-handle>{v.thumb ? <img src={v.thumb} alt="" /> : <div className="hk-video-blank" />}<span className="hk-video-play"><Play className="h-6 w-6 fill-current" /></span></div>
      ) : (
        <div className="hk-video-empty"><Youtube className="h-5 w-5" /><span>Lim inn ei YouTube- eller Vimeo-lenkje under</span></div>
      )}
      <div className="hk-inline-form">
        <input value={node.attrs.url} onChange={(e) => updateAttributes({ url: e.target.value.trim() })} placeholder="https://www.youtube.com/watch?v=…" aria-label="Videolenkje" className="font-mono" data-testid="editor-video-url" />
        {node.attrs.url && !v && <span className="hk-muted text-[12px]">Berre YouTube og Vimeo er støtta</span>}
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={deleteNode} className="is-danger" title="Fjern videoen" aria-label="Fjern videoen" data-testid="editor-video-remove"><Trash2 className="h-3.5 w-3.5" /></button>
      </div>
    </NodeViewWrapper>
  );
};

/** <div data-type="video" data-url><a href>Sjå videoen</a></div> – click-to-play facade on the public page, never an iframe in the stored HTML. */
export const Video = Node.create({
  name: "video",
  group: "block",
  atom: true,
  draggable: true,
  addAttributes() { return { url: { default: "", parseHTML: (el) => el.getAttribute("data-url") || "" } }; },
  parseHTML() { return [{ tag: 'div[data-type="video"]' }]; },
  renderHTML({ node }) { return ["div", { "data-type": "video", "data-url": node.attrs.url || "" }, ["a", { href: node.attrs.url || "#", target: "_blank", rel: "noopener noreferrer" }, "Sjå videoen"]]; },
  addNodeView() { return ReactNodeViewRenderer(VideoView); },
});
